module.exports = __webpack_public_path__ + "img/ico-15-active.4fcaca35.svg";